var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "ring-icon-analytics",
  "use": "ring-icon-analytics-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"ring-icon-analytics\"><path d=\"M14.99 5.26L8.87 10.5 6.25 8.76l-2.62 2.62-2.62-2.35V14h13.98V5.26z\" /><path d=\"M8.87 7.79L6.25 6.04 3.63 8.66 1.01 6.31v1.75l2.62 2.35 2.62-2.62 2.62 1.74 6.12-5.24V2.54L8.87 7.79z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id